import styled, { css } from 'styled-components';
import { size } from '../../layout/helpers';

interface VStackProps {
  $spacing?: number;
}

export const VStack = styled.div.attrs(() => ({
  role: 'presentation',
}))<VStackProps>`
  display: flex;
  flex-direction: column;

  ${({ $spacing }) =>
    $spacing &&
    css`
      gap: ${size($spacing)};
    `}
`;
